import * as React from "react";

const SvgQueuesAnalyticsIcon = props => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M4 20V9H8V20H4ZM10 20V4H14V20H10ZM16 20V13H20V20H16Z" fill="currentColor" /></svg>;

export default SvgQueuesAnalyticsIcon;